"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._TextBoxField = exports.TextBoxField = exports.InlineTextBoxField = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../../common/utils");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _TextBoxField = /*#__PURE__*/function (_React$Component) {
  _inherits(_TextBoxField, _React$Component);
  var _super = _createSuper(_TextBoxField);
  function _TextBoxField() {
    var _this;
    _classCallCheck(this, _TextBoxField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.render = function () {
      var _this$props = _this.props,
        name = _this$props.name,
        handleChange = _this$props.handleChange,
        handleBlur = _this$props.handleBlur,
        value = _this$props.value,
        id = _this$props.id,
        disabled = _this$props.disabled,
        type = _this$props.type,
        title = _this$props.title,
        label = _this$props.label,
        maxLength = _this$props.maxLength,
        formControlClassName = _this$props.formControlClassName,
        semanticClassName = _this$props.semanticClassName,
        action = _this$props.action,
        errorMessages = _this$props.errorMessages,
        leftLabel = _this$props.leftLabel,
        rightLabel = _this$props.rightLabel,
        onRef = _this$props.onRef,
        placeholder = _this$props.placeholder,
        size = _this$props.size,
        errorId = _this$props.errorId,
        onKeyDown = _this$props.onKeyDown,
        displayError = _this$props.displayError,
        ariaLabelledBy = _this$props.ariaLabelledBy;
      var processedValue = value === null ? '' : value;
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Input, {
        maxLength: maxLength,
        id: id,
        className: "".concat(formControlClassName, " ").concat(semanticClassName),
        name: name,
        disabled: disabled,
        onChange: handleChange,
        onBlur: handleBlur,
        value: processedValue,
        type: type,
        title: title ? title : label,
        "aria-labelledby": ariaLabelledBy || id,
        "aria-describedby": displayError ? errorId : null,
        "aria-label": !_lodash.default.isEmpty(title) || !_lodash.default.isEmpty(label) ? '' : 'text box for: ' + "".concat(id) //For 508 compliance, use invisible labels for screen readers when no title or visible label is present
        ,
        action: action,
        size: size,
        ref: function ref(r) {
          onRef && onRef(r);
        },
        placeholder: placeholder,
        onKeyDown: onKeyDown
      });
    };
    return _this;
  }
  return _createClass(_TextBoxField);
}(_react.default.Component);
exports._TextBoxField = _TextBoxField;
_TextBoxField.propTypes = {
  /** For the question */
  value: _propTypes.default.any,
  /** Functions */
  handleChange: _propTypes.default.func.isRequired,
  handleBlur: _propTypes.default.func,
  onRef: _propTypes.default.func
};
var TextBoxField = (0, _utils.enhance)(_TextBoxField);
exports.TextBoxField = TextBoxField;
var InlineTextBoxField = (0, _utils.enhanceInline)(_TextBoxField);
exports.InlineTextBoxField = InlineTextBoxField;